module.exports = __webpack_public_path__ + "static/media/IELTS_logo.f66d24ac.png";